angular.module('b2bLoginApp.directives').directive('uploadCompanyProfilePhoto', function () {
    return {
        restrict: 'A',
        templateUrl: '/account/company-profile-public/upload-photo-directive.html',
        link: function (scope) {

            scope.photoUploadSuccessCallback = function(uploadResponse) {
                scope.data.profile.photos.push(uploadResponse.data);

                // slides are zero indexed, so reduce photos length by one
                scope.data.activeSlide = scope.data.profile.photos.length -1;

                return true;
            };

            scope.cropperWidth = 300;
            scope.cropperHeight = 200;
        }
    };
});
